"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _theme = require("../theme");
var _excluded = ["className", "tagName"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * A pre-stylized component for form headings that reacts to themes. Provide the component a `tagName` appropriate for the
 * current [document outline](http://html5doctor.com/outlines/).
 * Additional visual styling can be accomplished by passing in `font-*` utility classes.
 *
 * Any additional props will be passed through to the component.
 */

var FormHeading = function FormHeading(_ref) {
  var className = _ref.className,
    _ref$tagName = _ref.tagName,
    TagName = _ref$tagName === void 0 ? 'h2' : _ref$tagName,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_theme.ThemeContext.Consumer, null, function (theme) {
    var isDark = theme === _theme.themes.dark;
    var classList = (0, _classnames["default"])('text-xxs', 'text-bold', 'text-upper', _defineProperty(_defineProperty(_defineProperty({}, className, Boolean(className)), 'color-textWhiteSoft', isDark), 'color-textBlackSoft', !isDark));
    return /*#__PURE__*/_react["default"].createElement(TagName, _extends({
      className: classList
    }, otherProps));
  });
};
FormHeading.displayName = 'FormHeading';
FormHeading.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  /**
   * The HTML tagName or React component to be rendered. This should almost always be an
   * `h1`&ndash;`h6` element that forms a correct
   * [document outline](http://html5doctor.com/outlines/).
   */
  tagName: _propTypes["default"].string
} : {};
var _default = exports["default"] = FormHeading;